<template>
    <div class="container">
      <div class="row">
        <div class="col-12">
            <BaseComponent v-for="(component, index) in components" :key="index" :componentData="component"/>
        </div>
      </div>
    </div>
</template>

<script>
import BaseComponent from '../components/BaseComponent'
export default {
  name: "FullWidth",
  props: ["components", "acf_fc_layout"],
  components:{ BaseComponent}
};
</script>

<style lang="scss" scoped>
</style>
